<template>
  <div v-if="show" class="c-player o-block-link" @click.prevent="openChannel(channel.id)" :style="styleObject" data-action="open-radioplayer" data-position="sidebar">
    <div class="c-player__channel"><img :src="channel.img" class="c-player__channel-img" alt="" /></div>
    <div class="c-player__content" v-if="channel.lastPlay">
      <div class="c-player__now">Nu op {{channel.name}}</div>
      <div class="c-player__artist">{{channel.lastPlay.artist.name}}</div>
      <div class="c-player__title">{{channel.lastPlay.title}}</div>
    </div>

    <div v-if="activeChannel && buffering" class="loading c-player__icon"></div>
    <SvgIcon v-else-if="activeChannel" icon="playing" class="c-player__icon" :style="{ fill: channel.textColor }" />
    <SvgIcon v-else icon="play" class="c-player__icon" :style="{ fill: channel.textColor }" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { openPlayer } from '../../mixins/radioPlayer';
const IGNORE_CHANNEL_BACKGROUND = ['qmusic_be'];

export default {
  name: 'NavPlayer',
  mixins: [openPlayer],
  computed: {
    styleObject() {
      const style = {};
      const { backgroundColor, backgroundImage, textColor, id } = this.channel;
      if (backgroundImage && IGNORE_CHANNEL_BACKGROUND.indexOf(id) === -1) {
        style.backgroundImage = `url(${backgroundImage})`;
      }
      if (backgroundColor ) {
         style.backgroundColor = backgroundColor;
      }
      if (textColor) {
        style.color = textColor;
      }
      return style;
    },
    ...mapState({
      show: state => state.radioplayer.showNavPlayer,
      channels: state => state.channels.channels,
      activeChannel: state => state.radioplayer.activeChannel || false,
      defaultChannel: state => state.stations.stationId,
      buffering: state => state.radioplayer.buffering,
      channel: (state) => {
        const { activeChannel, lastChannel } = state.radioplayer;
        const channelId = activeChannel || lastChannel || state.stations.stationId;
        return  state.channels.channels.filter(channel => channel.id === channelId).pop() || {};
      },

    }),
  },
}
</script>
